import { openkit } from "../../library/database";

export const searchMonuments = async (info, page, pageSize) => {
  try {
    const query = {
      type: "monument",
      name: info.name,
      villages: info.villages,
      date: info.monument.date,
      category: info.monument.category,
      page,
      pageSize: info.pageSize,
      // immediateConfirmation: info.immediateConfirmation,
    };
    const resp = await openkit.custom.execute(
      "post",
      "search-monuments",
      null,
      {
        query,
      }
    );
    return resp;
  } catch (error) {
    console.log("error :>> ", error);
  }
};
